import getVisibleColumnIndexByField from "./getVisibleColumnIndexByField";
//--------------------
// is sr image column
//--------------------
export default function isSRImageColumn(col_idx, headings) {
  // console.log("------------------")
  // console.log("IN isSRImageColumn")
  // console.log("col_idx = " + col_idx)
  //---------------------------------------
  // locate both sr image cols in headings
  //---------------------------------------
  let col_idx1 = getVisibleColumnIndexByField(headings, "sr_roll_image");
  let col_idx2 = getVisibleColumnIndexByField(headings, "roll_off_image");
  //---------------------
  // check col threshold
  //---------------------
  if (col_idx >= col_idx1 && col_idx <= col_idx2) {
    // console.log("is SR col")
    return true;
  } else {
    // console.log("is NOT SR col")
    return false;
  }
}
